import { PAGES, type PageId } from '../pages'
import type { Health } from '../types'

interface Props {
  connected: boolean
  health: Health | null
  page: PageId
  onNavigate: (page: PageId) => void
}

/**
 * Üst şerit: marka + tek canlılık göstergesi.
 *
 * Gösterge iki ayrı koşulu birleştirir — tarayıcı↔backend soketi ve
 * gip2logger'ın EPİAŞ'tan aldığı ping. İkisi de sağlamsa "Canlı" (nabız
 * animasyonlu). Biri düşerse etiket ve renk değişir: aksi hâlde bağlantı
 * koptuğunda da "Canlı" yazar, ekrandaki donuk veri canlı sanılır.
 */
export function StatusBar({ connected, health, page, onNavigate }: Props) {
  const state = !connected ? 'down' : health?.alive ? 'live' : 'stale'

  const label = state === 'live' ? 'Canlı' : state === 'stale' ? 'Veri akmıyor' : 'Bağlantı yok'

  const age = health?.ageSeconds != null ? `${Math.round(health.ageSeconds)} sn önce` : 'bilinmiyor'
  const title =
    state === 'live'
      ? `EPİAŞ GİP'e bağlı · son ping ${age}`
      : state === 'stale'
        ? `Connector yanıt vermiyor · son ping ${age}`
        : 'Sunucu bağlantısı koptu — yeniden bağlanılıyor'

  return (
    <header className="statusbar">
      <div className="statusbar-left">
        {/* Logo: dolu bir kare ve onun sönük ikizi — gölge ticaretin görsel
            karşılığı. Yazı tipiyle değil şekille anlatıyor, küçük boyutta da
            okunuyor. */}
        <div className="brand">
          <span className="brand-mark" aria-hidden="true">
            <svg viewBox="0 0 26 26" width="24" height="24">
              <defs>
                <linearGradient id="brandGrad" x1="0" y1="0" x2="1" y2="1">
                  <stop offset="0%" stopColor="#6aa9f0" />
                  <stop offset="100%" stopColor="#3a6fbd" />
                </linearGradient>
              </defs>
              <rect className="mark-ghost" x="3.5" y="8.5" width="14" height="14" rx="4" />
              <rect className="mark-solid" x="8.5" y="3.5" width="14" height="14" rx="4" />
            </svg>
          </span>
          <span className="brand-title">
            <b>GİP</b> Simülasyon Merkezi
          </span>
        </div>

        <nav className="nav" aria-label="Sayfalar">
          {/* `mobileOnly` sayfalar burada yok: masaüstünde `İşlem` diye ayrı bir
              ekran yok, o içerik 2×2 ızgarada zaten açık. */}
          {PAGES.filter((item) => !item.mobileOnly).map((item) => (
            <button
              key={item.id}
              type="button"
              className={`nav-item${page === item.id ? ' active' : ''}`}
              aria-current={page === item.id ? 'page' : undefined}
              onClick={() => onNavigate(item.id)}
            >
              {item.label}
            </button>
          ))}
        </nav>
      </div>

      <span className={`live-chip ${state}`} title={title} role="status">
        <span className="live-dot" aria-hidden="true">
          <span className="live-ring" />
        </span>
        {label}
      </span>
    </header>
  )
}
